import { addLog } from 'assets/components/feedback/Feedback';
import ModalForm from 'assets/components/form/modalForm/ModalForm';
import ThemeModalFormDefault from 'assets/components/form/modalForm/themes/Theme.ModalForm.Default';
import Icon from 'assets/components/icon/Icon';
import DateInput from 'assets/components/inputs/dateInput/DateInput';
import MultilineTextInput from 'assets/components/inputs/multilineText/MultilineTextInput';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import { getLocales } from 'assets/locales/Locale';
import { date, defaultInputDateTimeFormat, defaultServerDateTimeFormat } from 'assets/utils/data/Date';
import { HttpStatus } from 'config/Api.Config';
import contractRefundCancelApi from 'models/sales/contractRefund/cancel/Api.ContractRefund.Cancel';
import { ContractRefundAction, useContractRefundProvider } from '../Sales.ContractRefund.Hooks';

export default function SalesContractRefundCancel() {
  const { lang } = getLocales();
  const { selected, pageRouter, findApi, listApi } = useContractRefundProvider();

  return (
    <ModalForm<Api.Sales.ContractRefund.Cancel.IRequest>
      subcomponents={ThemeModalFormDefault}
      dependencyArray={[selected]}
      title={lang.cancelRefund}
      default={{ cancelledAtUtc: date().tz('UTC').format(defaultServerDateTimeFormat) }}
      onCancel={() => pageRouter.updateParams({ id: selected.id.toString(), action: ContractRefundAction.INFO })}
      onSubmit={async (data) => {
        const res = await contractRefundCancelApi({ id: selected.id, ...data });
        if (res.status !== HttpStatus.ok) {
          addLog({ error: res.message });
          return;
        }

        addLog({ success: lang.saveSuccess });
        pageRouter.updateParams({ id: selected.id.toString(), action: ContractRefundAction.INFO });
        findApi.execute((b) => b);
        listApi.execute((b) => b);
      }}
      validation={(data, errors) => {
        if (!data?.cancellationNote?.trim()) errors.cancellationNote = lang.mustNotBeEmpty;
      }}
      render={({ form }) => (
        <FormWrapper>
          <DateInput
            name="cancelledAtUtc"
            label={lang.cancelledAt}
            dateTimeFormat={defaultInputDateTimeFormat}
            value={form.data?.cancelledAtUtc}
            error={form.errors?.cancelledAtUtc}
            onChange={form.update}
            icon={<Icon class="fas-calendar-alt" />}
          />
          <MultilineTextInput
            name="cancellationNote"
            label={lang.cancellationNote}
            value={form.data?.cancellationNote}
            error={form.errors?.cancellationNote}
            onChange={form.update}
          />
        </FormWrapper>
      )}
    />
  );
}
